import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes, Outlet } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "@/components/theme/ThemeProvider";
import { CompanyProvider } from "@/contexts/CompanyContext";
import { AppShell } from "@/components/layout/AppShell";
import Dashboard from "@/pages/Dashboard";
import Messages from "@/pages/Messages";
import Templates from "@/pages/Templates";
import Channels from "@/pages/Channels";
import Broadcasts from "@/pages/Broadcasts";
import Audience from "@/pages/Audience";
import Cascades from "@/pages/Cascades";
import Integration from "@/pages/Integration";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import AdminDashboard from "@/pages/AdminDashboard";
import Tenants from "@/pages/Tenants";
import NotFound from "@/pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter basename="/app">
          <CompanyProvider>
          <Routes>
            <Route element={<AppShell />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/templates" element={<Templates />} />
              <Route path="/channels" element={<Channels />} />
              <Route path="/broadcasts" element={<Broadcasts />} />
              <Route path="/audience" element={<Audience />} />
              <Route path="/cascades" element={<Cascades />} />
              <Route path="/integration" element={<Integration />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/admin" element={<Outlet />}>
                <Route index element={<AdminDashboard />} />
                <Route path="tenants" element={<Tenants />} />
              </Route>
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
          </CompanyProvider>
        </BrowserRouter>
      </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

const container = document.getElementById("app");
if (container) {
  createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
